/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioItemMetricsSchema = z.object({
  forecastedFinish: z.iso.datetime(),
  forecastedStart: z.iso.datetime(),
  latestFinishDate: z.iso.datetime().nullish(),
});
